const granStoredPort = [
  { id: 1, description: 'Puerto Rosario' },
  { id: 2, description: 'Puerto Bahía Blanca' },
  { id: 3, description: 'Puerto Quequén' },
  { id: 4, description: 'Puerto Buenos Aires' }
];

export default granStoredPort;
